// extracted by mini-css-extract-plugin
export var parcelRow = "_ry-0";